import React, {FC, useState, ChangeEvent, useEffect, ElementType}  from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import {Divider, SvgIconProps, Typography, Switch, RadioGroup, FormControlLabel, Radio } from '@mui/material';

import Avatar from '@mui/material/Avatar';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

//import Loader from "react-loader-spinner";
import {ThreeDots} from "react-loader-spinner";
import { useTranslation  } from 'react-i18next';
import { isFalsy } from 'utility-types';


//import Checkbox from '@mui/material/Checkbox';
import ListSubheader from '@mui/material/ListSubheader';

import { blue } from '@mui/material/colors';
import { useRecoilValue } from 'recoil';
import { currentUserSessionAtom } from 'library/store';


export interface BasicButtonListProps<T> {
    items: T[];
    valueKey : keyof T;
    displayKey : keyof T;

    descriptionKey? : keyof T;

    //initialItemsSelected?: any[],
    title? : string,

    icon: ElementType<SvgIconProps>;
    
    onItemClick?: (item: T ) => void;

    stateSelectedLanguage? : ['' | 'fr-FR' | 'en-US', React.Dispatch<React.SetStateAction<'' | 'fr-FR' | 'en-US'>>],
    
    // setSelectedItems?: React.Dispatch<React.SetStateAction<any[]>>; 
    // onItemCheckedChange?: (event: ChangeEvent<HTMLInputElement>,checked: boolean, item: T ) => void;
}

function  BasicButtonList<T>(props: BasicButtonListProps<T>) {

    const { t, i18n } = useTranslation();

    const {language: lg} = useRecoilValue(currentUserSessionAtom);

    const {items, valueKey, displayKey, descriptionKey, onItemClick, icon , title, stateSelectedLanguage} = props;

    //const [checkedItems, setCheckedItems] = useState<any[]>(initialItemsSelected || []);

    const [isItemClicked, setIsItemClicked] = useState(false);

    const handleCheckedChange = (event: ChangeEvent<HTMLInputElement>,checked: boolean, item: T ) => {
        //console.log(checkedItems);
        // const value = item[valueKey];
        // const newChecked = checkedItems.filter( v => v !== value ); 
        // if(checked)
        //     newChecked.push(value);

        //setCheckedItems(newChecked);    
        // if(setSelectedItems) setSelectedItems(newChecked);   
        // if(onItemCheckedChange) onItemCheckedChange(event, checked, item);        
    }


    const [reportLanguage, setReportLanguage] = useState<'' | 'fr-FR' | 'en-US'>(
                    !isFalsy(stateSelectedLanguage)?stateSelectedLanguage[0]:'fr-FR');
    const handleChangeLanguage = ( event: React.MouseEvent<HTMLElement>, newLanguage: '' | 'fr-FR' | 'en-US') => {
        
        if( newLanguage === null || newLanguage === undefined) return;
        //setLanguage(newLanguage);
        setReportLanguage(newLanguage);
        if(stateSelectedLanguage) stateSelectedLanguage[1](newLanguage);
      };

    const handleItemClick = async (item: T ) => {
        setIsItemClicked(true);
        if(onItemClick) {
            await onItemClick(item);
        }
        setIsItemClicked(false);
        //onItemClick?() => onItemClick(item): () => {}
    }

    const IconComponent = icon;

    const [selectedItemId, setSelectedItemId] = useState<number | null>(null);

    //useEffect( () => { setCheckedItems(initialItemsSelected || []);}, [initialItemsSelected] );

    return(
        <List dense component="div" role="list"
            sx={{ width: '100%',  bgcolor: 'background.paper', pb: '0px' }}
            subheader={ isItemClicked?<ThreeDots color='#00BFFF' height={'100%'} /> : 
                    <ListSubheader sx={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center', // Center the content horizontally
                        // pl: '100px', 
                        // pt: '24px',
                        pt: '24px', // Padding top for spacing
                        pb: '12px', // Padding bottom for spacing                        
                         }}>
                        <Typography
                            sx={{
                                color: 'primary', // (theme) => theme.palette.text.primary,
                                fontWeight: 'bold',
                                textAlign: 'center', // Ensure text is centered
                            }}>
                            {title}
                        </Typography>
                        {!isFalsy(stateSelectedLanguage) && <ToggleButtonGroup size="small"
                            color="primary"
                            value={reportLanguage}
                            exclusive
                            onChange={handleChangeLanguage}
                            aria-label="Small sizes"
                        >
                            {/* <ToggleButton value="">{t('Default')}</ToggleButton> */}
                            <ToggleButton 
                                value="fr-FR"
                                sx={{ 
                                    '&.Mui-selected': { 
                                      backgroundColor: 'primary.main', 
                                      color: 'white', 
                                      fontWeight: 'bold' 
                                    }
                                  }}>{t('French')}</ToggleButton>
                            <ToggleButton 
                                value="en-US"
                                sx={{ 
                                    '&.Mui-selected': { 
                                      backgroundColor: 'primary.main', 
                                      color: 'white', 
                                      fontWeight: 'bold' 
                                    }
                                  }}>{t('English')}</ToggleButton>                
                        </ToggleButtonGroup> }             
                    </ListSubheader> }
        >
            
            {items.map((item, idx) =>{ 
                //const labelId = `checkbox-list-label-${item[displayKey] as unknown as string}`;

                return (
                <ListItem button key={idx} role="listitem" onClick={() => handleItemClick(item)} disabled={isItemClicked} >
                    <ListItemAvatar>
                        <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                            <IconComponent />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                        id={item[valueKey] as unknown as string}
                        primary={
                            <Typography sx={{ color: 'primary', fontWeight: 'bold' }}>
                                {item[displayKey] as unknown as string}
                            </Typography>
                        }
                        secondary={
                            descriptionKey && item[descriptionKey] ? (
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    {item[descriptionKey] as unknown as string}
                                </Typography>
                            ) : null
                        }
                    />
{/* 
                    <ListItemText id={item[valueKey] as unknown as string}>
                        <Typography
                            sx={{ color: 'primary', fontWeight: 'bold', }} >
                            {item[displayKey] as unknown as string}
                        </Typography>
                    </ListItemText> */}
                </ListItem>
            )} )
            }
        </List>
    );

}

export default BasicButtonList;